import imageFallback from "@/assets/svg/image.svg";
import Badge from "@/components/ui/badge";
import { Image } from "@/components/ui/image";
import { Template } from "@/types/template";

export function TemplateCardComingSoon({ template }: { template: Template }) {
  const { title, short_description, thumbnail_icon } = template;

  return (
    <div
      className="group w-full h-full cursor-not-allowed rounded-xl border border-neutral-200 bg-white p-3 text-left transition-all"
      aria-disabled="true"
      aria-label={`${title} (Coming soon)`}
    >
      <div className="flex flex-col gap-2 h-full">
        <div className="relative flex h-[120px] w-full items-center justify-center rounded-lg bg-white-smoke transition-colors">
          <Badge
            variant="disabled"
            className="text-light-gray absolute right-2 top-2"
          >
            Coming Soon
          </Badge>
          <div className="flex h-16 w-16 items-center justify-center rounded-full bg-light-gray transition-colors">
            <Image
              src={thumbnail_icon.url}
              alt={title}
              fallbackSrc={imageFallback}
              className="h-8 w-8"
            />
          </div>
        </div>
        <div className="flex flex-col space-y-1">
          <p className="truncate text-sm font-semibold text-light-gray">
            {title}
          </p>
          <p className="truncate text-xs text-light-gray">
            {short_description}
          </p>
        </div>
      </div>
    </div>
  );
}
